function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect, Children, cloneElement, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { ClickListener, useListFocus, useEscape, useTabOut } from '@nt/dds-utils';
import throttle from 'lodash/throttle';
import PortalPanel from '../Panel/PortalPanel';
import Button from '../Button/index';
var DropdownMenu = function DropdownMenu(_ref) {
  var id = _ref.id,
    buttonText = _ref.buttonText,
    buttonKind = _ref.buttonKind,
    buttonIcon = _ref.buttonIcon,
    buttonIconName = _ref.buttonIconName,
    buttonSize = _ref.buttonSize,
    children = _ref.children,
    disabled = _ref.disabled,
    _ref$panelHeight = _ref.panelHeight,
    panelHeight = _ref$panelHeight === void 0 ? 'auto' : _ref$panelHeight,
    _ref$panelWidth = _ref.panelWidth,
    panelWidth = _ref$panelWidth === void 0 ? 240 : _ref$panelWidth,
    _ref$alignRight = _ref.alignRight,
    alignRight = _ref$alignRight === void 0 ? false : _ref$alignRight,
    portalContainerId = _ref.portalContainerId;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    options = _useState4[0],
    setOptions = _useState4[1];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    btnRect = _useState6[0],
    setBtnRect = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    panelLeftPos = _useState8[0],
    setPanelLeftPos = _useState8[1];
  var _useState9 = useState(),
    _useState10 = _slicedToArray(_useState9, 2),
    isActive = _useState10[0],
    setActive = _useState10[1];
  var _useState11 = useState(0),
    _useState12 = _slicedToArray(_useState11, 2),
    panelTopPos = _useState12[0],
    setPanelTopPos = _useState12[1];
  var _useState13 = useState(-1),
    _useState14 = _slicedToArray(_useState13, 2),
    startIndex = _useState14[0],
    setStartIndex = _useState14[1];
  var _useState15 = useState(),
    _useState16 = _slicedToArray(_useState15, 2),
    keepFocus = _useState16[0],
    setKeepFocus = _useState16[1];
  var buttonRef = useRef(null);
  var panelRef = useRef(null);
  useEffect(function () {
    var items = [];
    if (panelRef.current) {
      items = panelRef.current.querySelectorAll('[role="menuitem"]');
    }
    setOptions(Array.from(items));
  }, [panelRef, isOpen]);
  var setFocus = function setFocus(item) {
    item.focus();
  };
  var handleSubMenu = function handleSubMenu(props) {
    setActive(!props);
    if (!props) {
      setKeepFocus(false);
    } else {
      setKeepFocus(true);
    }
  };
  useListFocus(panelRef, '[role="menuitem"]', isActive, setFocus, options, startIndex, keepFocus);
  var close = useCallback(function () {
    if (isOpen) {
      setIsOpen(false);
      setStartIndex(-1);
    }
  }, [isOpen]);
  useEscape(close, isOpen, buttonRef);
  useTabOut(close, isOpen);
  var update = useCallback(function () {
    var buttonRect = buttonRef.current.getBoundingClientRect();

    // Set left position
    if (buttonRect.left + panelWidth > window.innerWidth || alignRight) {
      var leftPos = buttonRect.left - panelWidth + buttonRect.width;
      setPanelLeftPos(leftPos);
    } else {
      setPanelLeftPos(buttonRect.left);
    }
    //set top position
    var getTopOffsetSum = function getTopOffsetSum(ele) {
      var top = 0;
      while (ele) {
        top += ele.offsetTop;
        ele = ele.offsetParent;
      }
      return top;
    };
    var topOffsetSum = getTopOffsetSum(buttonRef.current);
    setPanelTopPos(topOffsetSum + buttonRect.height);
    setBtnRect(buttonRect);
  }, [alignRight, buttonRef, panelWidth]);
  useEffect(function () {
    window.addEventListener('resize', function () {
      close();
      throttle(update, 200);
    });
    update();
    return function () {
      return window.removeEventListener('resize', close);
    };
  }, [isOpen, close, update]);
  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setIsOpen(true);
      setActive(true);
    }
    if (e.key === 'ArrowUp') {
      e.preventDefault();
      setIsOpen(false);
      setActive(false);
    }
  };
  return /*#__PURE__*/React.createElement(ClickListener, {
    onClickOutside: close
  }, /*#__PURE__*/React.createElement(Button, {
    id: id,
    kind: buttonKind,
    icon: buttonIcon || 'right',
    iconName: buttonIconName || (isOpen ? 'menu_up' : 'menu_down'),
    size: buttonSize,
    disabled: disabled,
    onClick: function onClick() {
      !disabled && setIsOpen(!isOpen);
      setActive(true);
    },
    ref: buttonRef,
    "aria-haspopup": "true",
    "aria-controls": "".concat(id, "_Menu"),
    "aria-expanded": isOpen.toString(),
    onKeyDown: !disabled && handleKeyDown
  }, buttonText), isOpen && /*#__PURE__*/React.createElement("div", {
    className: "position-relative"
  }, /*#__PURE__*/React.createElement(PortalPanel, {
    noPadding: true,
    className: "paddingtop-md paddingbottom-md",
    height: panelHeight,
    width: panelWidth,
    isOpen: isOpen,
    triggerSize: buttonSize,
    top: panelTopPos,
    left: panelLeftPos,
    ref: panelRef,
    portalContainerId: portalContainerId
  }, /*#__PURE__*/React.createElement("ul", {
    role: "menu",
    id: "".concat(id, "_Menu"),
    "aria-labelledby": id
  }, Children.map(children, function (child) {
    return cloneElement(child, {
      onClick: function onClick() {
        child.props.onClick();
        close();
      },
      onSubMenuOpen: handleSubMenu
    });
  })))));
};
DropdownMenu.propTypes = {
  /** Unique ID for the menu button for accessibility */
  id: PropTypes.string.isRequired,
  /** Text to display within the toggle button */
  buttonText: PropTypes.string,
  /** Style of the Button (primary, secondary, tertiary, borderless) */
  buttonKind: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'borderless']),
  /** indicates whether the button should have an icon on left, right, none, or only if it's just an icon button without text. Must also pass `buttonIconName` */
  buttonIcon: PropTypes.oneOf(['right', 'left', 'none', 'only']),
  buttonIconName: PropTypes.string,
  /** size of the button for dropdownKind 'menu'. */
  buttonSize: PropTypes.oneOf(['small', 'medium', 'large']),
  /** aria-label for menu button, used when menu button is icon only */
  buttonAriaLabel: PropTypes.string,
  children: PropTypes.node,
  /** Disables the button when set to true */
  disabled: PropTypes.bool,
  /** Height of the menu panel. Default height is 'auto' based on your amount of menuitem */
  panelHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Width of the menu panel */
  panelWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Sets the menu panel to be aligned right to the button */
  alignRight: PropTypes.bool,
  /** Id of the parent container for portal(if not provided the portal will be attached to document.body by default)  */
  portalContainerId: PropTypes.string
};
DropdownMenu.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "DropdownMenu",
  "props": {
    "panelHeight": {
      "defaultValue": {
        "value": "'auto'",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false,
      "description": "Height of the menu panel. Default height is 'auto' based on your amount of menuitem"
    },
    "panelWidth": {
      "defaultValue": {
        "value": "240",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false,
      "description": "Width of the menu panel"
    },
    "alignRight": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Sets the menu panel to be aligned right to the button"
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "Unique ID for the menu button for accessibility"
    },
    "buttonText": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Text to display within the toggle button"
    },
    "buttonKind": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "'primary'",
          "computed": false
        }, {
          "value": "'secondary'",
          "computed": false
        }, {
          "value": "'tertiary'",
          "computed": false
        }, {
          "value": "'borderless'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Style of the Button (primary, secondary, tertiary, borderless)"
    },
    "buttonIcon": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "'right'",
          "computed": false
        }, {
          "value": "'left'",
          "computed": false
        }, {
          "value": "'none'",
          "computed": false
        }, {
          "value": "'only'",
          "computed": false
        }]
      },
      "required": false,
      "description": "indicates whether the button should have an icon on left, right, none, or only if it's just an icon button without text. Must also pass `buttonIconName`"
    },
    "buttonIconName": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "buttonSize": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "'small'",
          "computed": false
        }, {
          "value": "'medium'",
          "computed": false
        }, {
          "value": "'large'",
          "computed": false
        }]
      },
      "required": false,
      "description": "size of the button for dropdownKind 'menu'."
    },
    "buttonAriaLabel": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "aria-label for menu button, used when menu button is icon only"
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Disables the button when set to true"
    },
    "portalContainerId": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Id of the parent container for portal(if not provided the portal will be attached to document.body by default)"
    }
  }
};
export default DropdownMenu;